import Text from '@cartwhl/ui/base/Text';

interface OpeningsDescriptionProps {
  title: string;
  description: string;
}

export default function OpeningsDescription({
  title,
  description,
}: OpeningsDescriptionProps) {
  return (
    <section className="max-w-[632px]">
      <Text as="h2" variant="web/body/medium/lg" className="mb-5">
        {title}
      </Text>
      <Text as="p" variant="web/body/md">
        {description}
      </Text>
    </section>
  );
}
